import { Organisation } from "callable-data-objects";
import { DBReference } from "callable-data-objects/dist/models/accountDevice/AccountDevice";
import { Role } from "callable-data-objects/dist/models/role";
import { useOrganisation, useRole } from "Hooks/Endpoints";
import React from "react";
import { Button, Label, Table } from "semantic-ui-react";
import { SemanticCOLORS } from "semantic-ui-react/dist/commonjs/generic";

type OrganisationRolesProps = {
  organisation: Organisation;
};

const OrganisationRoles = ({ organisation }: OrganisationRolesProps) => {
  const { addRole, removeRole } = useOrganisation();
  const { roles } = useRole();

  const connected = (id: string) => {
    return (
      organisation.roles?.find((r: DBReference) => r.id === id) !== undefined
    );
  };

  const getColor = (id: string): SemanticCOLORS => {
    return connected(id) ? "red" : "blue";
  };

  return (
    <Table singleLine stackable padded striped>
      <Table.Header>
        <Table.HeaderCell></Table.HeaderCell>
        <Table.HeaderCell>Name</Table.HeaderCell>
        <Table.HeaderCell>Description</Table.HeaderCell>
        <Table.HeaderCell>Actions</Table.HeaderCell>
      </Table.Header>
      <Table.Body>
        {roles.map((r: Role) => (
          <Table.Row key={r.id}>
            <Table.Cell width={1}>
              {connected(r.id) ? (
                <Label color='blue' ribbon>
                  Assigned
                </Label>
              ) : (
                ""
              )}
            </Table.Cell>
            <Table.Cell width={3}>{r.name}</Table.Cell>
            <Table.Cell width={4}>{r.description}</Table.Cell>
            <Table.Cell width={2}>
              <Button
                color={getColor(r.id)}
                onClick={() =>
                  connected(r.id) ? removeRole(r.id) : addRole(r.id)
                }
              >
                {connected(r.id) ? "Revoke" : "Assign"}
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default OrganisationRoles;
